export default __webpack_public_path__ + "static/nesGlobal-467a80c6f62af7484949a08545380198.svg";